import { IMAGE_LIBRARY_TYPE, ImageLibraryType } from "./types";

/**
 * Cloudinary file ids are hexadecimal: own uploads get 4 bytes (8 characters)
 * from the menu/website media endpoints, AI images of the image library get
 * 3 bytes (6 characters). AI images are linked by their id, never re-uploaded.
 */
const AI_FILE_ID = /^[0-9a-f]{6}$/i;

/** ImageLibrary_ImageType_ValueEnum::getCloudinaryPath on the backend. */
const LIBRARY_FOLDERS: Record<ImageLibraryType, string> = {
  [IMAGE_LIBRARY_TYPE.slider]: "slider",
  [IMAGE_LIBRARY_TYPE.product]: "products",
  [IMAGE_LIBRARY_TYPE.topping]: "toppings",
  [IMAGE_LIBRARY_TYPE.category]: "categories",
  [IMAGE_LIBRARY_TYPE.flyer]: "flyers",
};

/** File id of a cloudinary id ("v123/c7589ad5.jpg") or a full image url. */
export const getCloudinaryFileId = (image?: string | null) =>
  (image ?? "").split("?")[0].split("/").pop()?.split(".")[0] ?? "";

/** Whether the cloudinary id or url points to an AI image (3 byte file id). */
export const isAiImage = (image?: string | null) =>
  AI_FILE_ID.test(getCloudinaryFileId(image));

/** ImageLibrary_ImageType_ValueEnum::getCloudinaryUrl on the backend. */
export const getLibraryImageUrl = (
  image: string,
  imageType: ImageLibraryType
) => {
  const transformation =
    imageType === IMAGE_LIBRARY_TYPE.slider ? "c_fill,w_1670,h_460/" : "";
  return `${import.meta.env.VITE_CLOUDINARY_BASE_URL}/${transformation}cms/image-library/${
    LIBRARY_FOLDERS[imageType]
  }/${getCloudinaryFileId(image)}`;
};
